import { render, staticRenderFns } from "./IconWarningWhite.vue?vue&type=template&id=ebad6596&functional=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('ebad6596', component.options)
    } else {
      api.rerender('ebad6596', component.options)
    }
    module.hot.accept("./IconWarningWhite.vue?vue&type=template&id=ebad6596&functional=true&", function () {
      api.rerender('ebad6596', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_base/IconWarningWhite.vue"
export default component.exports